// extracted by mini-css-extract-plugin
export var phone = "_39-0";
export var phoneDragging = "_39-1";